package org.tlsys.jobs.api

const val INVOKATOR="JobService"